module.exports = __webpack_public_path__ + "img/amex.73bf1fb9.svg";